// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// aliased
import Link from 'components/Link';

// local
import styles from './LinkList.pcss';


export default class LinkList extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
    hidden: PropTypes.bool,
    links: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string,
    })),
  }
  static defaultProps = {
    hidden: false,
  }
  
  get links() {
    const { links } = this.props;
    return links.map(({ url, title }, i) => (
      <li key={ i }>
        <Link className={ styles.link } to={ url }>{ title }</Link>
      </li>
    ));
  }

  render() {
    const { className, hidden } = this.props;
    if (hidden) return null;
    const classes = classnames(className, styles.linkList);
    
    return (
      <ul className={ classes }>
        { this.links }
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectDetails/LinkList/index.jsx